import require from '@/utils/request'

import {
  PlanUpdataFrom,
  PlanPageDetailForm,
  PlanAddForm,
  PlanUpdataForm,
  PlanExecuteRecordDetailForm,
  PlanCategorylListForm } from '@/types/PlanAdmin'

import { WebhookUpdataForm } from '@/types/Webhook'
/**
 *
 * @param data
 *
 * 运营计划执行记录
 *   * 运营计划类列 add  CategoryAdd
  * 运营计划类别list    CategoryList
  * 运营计划分页    plan/page
 * PlanDetail 运营计划详情分页
 * PlanPageDetail 分页查询计划执行记录
 * PlanExecuteRecordDetail   运营计划执行记录明细
 * PlanDetailList 选择计划下拉框列表
 *
 * 计划日志
 * planExecuteRecordDetail/detail 单条查询
 *
 * 新增
 * PlanAdd             新增第一步
 * PlanConfigTrigger   配置触发条件 第二步
 * PlanWebhookAdd      新增webhook任务 第三步
 *
 * PlanDelate         删除
 *
 * PlanUpdata         更新
 */

export const PlanDetail = (id: number) => require({
  url: '/plan/detail/' + id,
  method: 'get'
})
export const PlanCategoryAdd = (data:PlanUpdataFrom) => require({
  url: '/planCategory/add',
  method: 'post',
  data
})
export const PlanCategorypage = (data:PlanUpdataFrom, planCategoryId:number, name:string) => require({
  url: `/plan/page?planCategoryId=${planCategoryId}&name=${name}`,
  method: 'post',
  data
})
export const PlanPageDetail = (data: PlanPageDetailForm) => require({
  url: '/planExecuteRecord/page?planId=' + data.planId,
  method: 'post',
  data
})
export const PlanExecuteRecordDetail = (data:PlanExecuteRecordDetailForm) => require({
  url: '/planExecuteRecordDetail/queryPage',
  method: 'post',
  data
})
export const PlanCategorylList = (params:PlanCategorylListForm) => require({
  url: '/planCategory/list/',
  method: 'get',
  params
})

export const PlanSingleDeatil = (id:number) => require({
  url: '/planExecuteRecordDetail/detail/' + id,
  method: 'get'
})

export const PlanAdd = (data:PlanAddForm) => require({
  url: '/plan/add',
  method: 'post',
  data
})
export const PlanUpdata = (params:string) => require({
  url: '/plan/update' + params,
  method: 'post',

})
export const PlanConfigTrigger = (groupIds:number[], id:number, cron:string, triggerType:number) => require({
  url: '/plan/configTrigger/' + id + '?cron=' + cron + '&triggerType=' + triggerType,
  method: 'post',
  data: groupIds
})
export const PlanWebhookAdd = (data:WebhookUpdataForm) => require({
  url: '/planExecuteWebhook/add',
  method: 'post',
  data
})

export const PlanDelate = (id: number) => require({
  url: '/planCategory/delete/' + id,
  method: 'post'
})

export const PlanCategoryUpdata = (data:PlanUpdataFrom) => require({
  url: '/planCategory/update',
  method: 'post',
  data
})

export const PlanEnable = (id:number) => require({
  url: '/plan/enable/' + id,
  method: 'post'
})
export const PlanDisable = (id:number) => require({
  url: '/plan/disable/' + id,
  method: 'post'
})

export const PlanLogExport = '/bi/planExecuteRecordDetail/export'
